<template>
  <b-alert :show="dismissCountDown" :dismissible="dismissible" fade :variant="variant" @dismissed="dismissCountDown=0">
    <span v-html="alertContent"></span>
    <slot name="content"></slot>
  </b-alert>
</template>
<script type="text/javascript">
import Vue from 'vue'
export default {
  name: 'FITAlert',
  props: {
  alertContent: {
      type: String,
      required: false,
      default: ''
    },
    alertSec: {
      type: Number,
      required: true
    },
    variant: {
      type: String,
      default: 'success'
    },
    dismissible: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      dismissCountDown: 0
    }
  },
  methods: {
    showAlert() {
      Vue.set(this, 'dismissCountDown', this.alertSec);
    },
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Form/FITAlert.vue